import {
  defineComponent,
  getCurrentInstance,
  reactive,
  watch
} from '@vue/composition-api'
import './index.scss'
import _ from 'lodash'
import { blurCheckInput } from '../../topicCommonUtil'
import VueI18n from 'vue-i18n'
const CheckboxContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    i18n: {
      type: VueI18n
    },
    isViewAnswer: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { emit } = context
    const vm = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      errorText: '',
      isMin: false,
      isMax: false
    })
    watch(
      () => props.item,
      (val) => {
        state.editItem = _.cloneDeep(val)
      },
      {
        deep: true
      }
    )

    const checkboxInput = (value) => {
      if (props.isViewAnswer) return
      if (
        props.item.topicSetting.optionLengthLessThan &&
        value.length > props.item.topicSetting.optionLengthLessThan
      ) {
        state.isMin = false
        state.isMax = true
        return false
      }
      if (
        props.item.topicSetting.optionLengthMoreThan &&
        value.length < props.item.topicSetting.optionLengthMoreThan
      ) {
        state.isMin = true
        state.isMax = false
      }
      if (
        props.item.topicSetting.optionLengthMoreThan &&
        props.item.topicSetting.optionLengthLessThan &&
        value.length >= props.item.topicSetting.optionLengthMoreThan &&
        value.length <= props.item.topicSetting.optionLengthLessThan
      ) {
        state.isMax = false
        state.isMin = false
      }
      //增加互斥逻辑
      const filterIsExclusive = state.editItem.topicSetting.topicOptionSetting
        .filter((i) => i.isExclusive)
        .map((i) => i.optionId)

      if (filterIsExclusive.length > 0 && value.length > 1) {
        if (filterIsExclusive.includes(value[0])) {
          value.shift()
        } else if (filterIsExclusive.includes(value[value.length - 1])) {
          value.splice(0, value.length - 1)
        }
      }
      state.editItem.values = value
      state.editItem.inputErrorTips = ''
      state.editItem.isShowInputError = false
      state.editItem.isShowTitleError = false
      emit('answer', state.editItem)
    }

    const focusInput = (value, sitem) => {
      //当没有选中该项的时候需要做数据处理
      if (state.editItem.values.indexOf(sitem.optionId) === -1) {
        if (
          props.item.topicSetting.optionLengthLessThan &&
          state.editItem.values.length >=
            props.item.topicSetting.optionLengthLessThan
        ) {
          state.isMin = false
          state.isMax = true
          return false
        } else if (
          props.item.topicSetting.optionLengthMoreThan &&
          state.editItem.values.length + 1 <
            props.item.topicSetting.optionLengthMoreThan
        ) {
          state.isMin = true
          state.isMax = false
          state.editItem.values.push(sitem.optionId)
        } else {
          state.isMin = false
          state.isMax = false
          state.editItem.values.push(sitem.optionId)
        }
      }
      const valueArr = [...state.editItem.values]
      //增加互斥逻辑
      const filterIsExclusive = state.editItem.topicSetting.topicOptionSetting
        .filter((i) => i.isExclusive)
        .map((i) => i.optionId)
      if (filterIsExclusive.length > 0 && valueArr.length > 1) {
        if (filterIsExclusive.includes(valueArr[0])) {
          state.editItem.values.shift()
        } else if (filterIsExclusive.includes(valueArr[valueArr.length - 1])) {
          state.editItem.values.splice(0, valueArr.length - 1)
        }
      }
      emit('answer', state.editItem)
    }

    return () => {
      return (
        <div class="checkbox-topic-content">
          <div class="checkbox-max-min-tips">
            {props.item.topicSetting.optionLengthMoreThan && (
              <span
                class={{
                  'select-max-min-tips': true,
                  'select-max-min-tips-red': state.isMin
                }}>
                {props.i18n?.t('survy.lesschose') || tran('survy.lesschose')}{' '}
                {props.item.topicSetting.optionLengthMoreThan}{' '}
                {props.i18n?.t('survy.item') || tran('survy.item')}{' '}
              </span>
            )}
            {props.item.topicSetting.optionLengthLessThan && (
              <span
                class={{
                  'select-max-min-tips': true,
                  'select-max-min-tips-red': state.isMax
                }}>
                {props.i18n?.t('survy.mostchose') || tran('survy.mostchose')}{' '}
                {props.item.topicSetting.optionLengthLessThan}{' '}
                {props.i18n?.t('survy.item1') || tran('survy.item1')}
              </span>
            )}
          </div>
          <el-checkbox-group
            value={state.editItem.values}
            onInput={(value) => checkboxInput(value)}>
            {(props.item?.topicSetting?.topicOptionSetting || []).map(
              (sitem) => {
                return (
                  <div
                    class={{
                      'check-item-contain-input': !!sitem.isAddText,
                      'check-box-item': true
                    }}>
                    <el-checkbox label={sitem.optionId}>
                      <div>
                        <span domPropsInnerHTML={sitem.optionName}></span>
                        {state.editItem.values.includes(sitem.optionId) && (
                          <span class="el-radio-error">
                            {state.editItem['inputErrorTips_' + sitem.optionId]}
                          </span>
                        )}
                      </div>
                      {sitem.isAddText &&
                        state.editItem.values.includes(sitem.optionId) && (
                          <div class="check-box-item-label">
                            {!props.isViewAnswer && (
                              <el-input
                                type="textarea"
                                autosize={{ minRows: 1, maxRows: 5 }}
                                maxlength="1000"
                                show-word-limit
                                onfocus={(value) => focusInput(value, sitem)}
                                onblur={(value) =>
                                  blurCheckInput(value, sitem, state, emit)
                                }
                                value={
                                  state.editItem['inputValue_' + sitem.optionId]
                                }
                                onInput={(value) => {
                                  state.editItem[
                                    'inputValue_' + sitem.optionId
                                  ] = value
                                  emit('answer', state.editItem)
                                }}
                                class="check-box-item-input"
                                size="small"
                                placeholder={props.i18n?.t(
                                  'survy.plccontent'
                                )}></el-input>
                            )}
                            {props.isViewAnswer && (
                              <el-tooltip
                                placement="bottom"
                                disabled={
                                  !state.editItem[
                                    'inputValue_' + sitem.optionId
                                  ]
                                }
                                content={
                                  state.editItem['inputValue_' + sitem.optionId]
                                }>
                                <el-input
                                  type="textarea"
                                  autosize={{ minRows: 1, maxRows: 5 }}
                                  maxlength="1000"
                                  show-word-limit
                                  value={
                                    state.editItem[
                                      'inputValue_' + sitem.optionId
                                    ]
                                  }
                                  class="check-box-item-input"
                                  size="small"
                                  placeholder={props.i18n?.t(
                                    'survy.plccontent'
                                  )}></el-input>
                              </el-tooltip>
                            )}
                          </div>
                        )}
                    </el-checkbox>
                  </div>
                )
              }
            )}
          </el-checkbox-group>
        </div>
      )
    }
  }
})
export default CheckboxContent
